
// Public_Routes.js

import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import CadastroNovoUsuPage from '../pages/NovoUsuarioPage';

const PublicRoutes = () => {
  return (
    //<BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/novousuario" element={<CadastroNovoUsuPage />} />
      </Routes>
    //</BrowserRouter>
  );
};

export default PublicRoutes;